import { ADDRESS_BY_ZIP_CODE_URL } from '@/constants';
import { FormAddress } from '@/types';
import { HttpStatusCode, fromBff, httpClient } from '@/utils';
import { NotFoundError, UnauthorizedError, UnexpectedError } from '@/services';
import { parseAddressByZipCode } from './parser';

const notFoundError = new NotFoundError(
  'O CEP não foi encontrado. Preencha os dados manualmente ou verifique o CEP digitado.',
);

export const loadAddressByZipCodeService = async (zipCode: string): Promise<Partial<FormAddress>> => {
  const uri = fromBff(`${ADDRESS_BY_ZIP_CODE_URL}/${zipCode}`);
  const { body, status } = await httpClient.get(uri);

  const handleResult = () => {
    if (!Boolean(Object.keys(body?.data || {}).length)) throw notFoundError;
    return parseAddressByZipCode(body.data);
  };

  switch (status) {
    case HttpStatusCode.ok:
      return handleResult();

    case HttpStatusCode.notFound:
      throw notFoundError;

    case HttpStatusCode.unauthorized:
      throw new UnauthorizedError();

    default:
      throw new UnexpectedError();
  }
};
